/**
 * UI offre carte BonSpot en caisse.
 * Le refus n’est **pas** persisté : à chaque nouvelle sélection client sans carte,
 * on repropose la modale. Le bandeau « refusé » ne vaut que pour la sélection en cours.
 */

export type LoyaltyPassOfferUiState =
  | 'hidden'
  | 'offer'
  | 'declined'
  | 'needsPhone'
  | 'status';

/** Décide l’UI caisse pour un client sélectionné (testable). */
export function resolveLoyaltyPassOfferUi(input: {
  featureOn: boolean;
  clientId?: string | null;
  passId?: string | null;
  hasPhone: boolean;
  declinedForCurrentSelection: boolean;
}): LoyaltyPassOfferUiState {
  if (!input.featureOn || !input.clientId) return 'hidden';
  if (input.passId) return 'status';
  if (!input.hasPhone) return 'needsPhone';
  if (input.declinedForCurrentSelection) return 'declined';
  return 'offer';
}
